<template>
  <small>{{ description }}</small>
</template>

<script>
  export default {
    name: "FieldDescriptor",
    props: {
      description: {
        type: String,
        required: false,
      },
    },
  };
</script>

<style scoped>
  small {
    color: #666;
    font-size: 12px;
    font-style: italic;
  }
</style>
